import React from "react";
import classes from './ItemInvest.module.scss'

export const ItemInvest = (props :any) => {
    return(
        <div className={classes.invest}>
            <img className={classes.invest_img} src={props.img} alt = 'battery'/>
            <div className={classes.invest__amount}>
                <p className={classes.invest__amount_number}>{props.number}</p>
                <p className={classes.invest__amount_tokens}>Tokens</p>
            </div>
            <p className={classes.invest_descr}>{props.descr}</p>
        </div>
    )
}